import React from 'react';
import displayName from 'component-lib/displayName';
import styles from './AppHeader.scss';

import { HELP_MENU } from './config';
import mapMenuItems from './utils/mapMenuItems';
import renderEnabledMenuItems from './utils/renderEnabledMenuItems';
import generateMenuPropTypes from './utils/generateMenuPropTypes';
import menuCloseHoverHandler from './MenuCloseHoverHandler';

const BASE_KEY = 'components.app_header.help_menu';
const ITEM_MAPPINGS = mapMenuItems(HELP_MENU.ITEMS, BASE_KEY);

// TODO: figure out a way for this not to error out
/* eslint-disable react/prop-types */
const component = function HelpMenu(props) {
    return (
        <div
            data-menu="information"
            className={`${styles['dropdown-container']} ${props.menuClassName}`}
            onMouseOver={props.showMenu}
        >
            <span className={styles['icon-help']} />
            <div className={styles['dropdown-div']}>
                {renderEnabledMenuItems(ITEM_MAPPINGS, props, props.hideMenu)}
            </div>
        </div>
    );
};
/* eslint-enable react/prop-types */

component.displayName = displayName('AppHeader/HelpMenu');
component.propTypes = generateMenuPropTypes(ITEM_MAPPINGS);

const HelpMenu = menuCloseHoverHandler(component);

export default HelpMenu;
